module.exports = __webpack_public_path__ + "assets1763535487631/img/error-401.98bba5b1.svg";